import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RadioButtonModule } from '../../forms/radio-button/radio-button.module';
import { RadioSectionComponent } from './radio-section.component';

@NgModule({
  imports: [CommonModule, RadioButtonModule],
  declarations: [RadioSectionComponent],
  exports: [RadioSectionComponent]
})
export class RadioSectionModule {}
